import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { bindActionCreators, compose } from 'redux';
import { Toast } from '@como/web-hub-components';
import injectSaga from '../../utils/injectSaga';
import * as emailsActions from './emails.actions';
import * as emailsSelectors from './emails.selectors';
import saga from './emails.saga';
import './emails.styles.less';
import SideNavBar from '../SideNavBar/SideNavBar';
import tracker from '../../common/utils/tracking/tracker';
import * as trackerConstants from '../../common/utils/tracking/tracking.consts';
import { setLoadingState } from '../App/app.actions';
import EmailsPageToolbar from './views/EmailsPageToolbar';
import * as routerConstants from '../../constants/reducer.constants';
import * as appSelectors from '../App/selectors';
import * as constants from './emails.constants';
import * as businessCenterActions from '../BusinessCenter/businessCenter.actions';
import businessSaga from '../BusinessCenter/businessCenter.saga';
import { getSideNavbarSettings } from '../BusinessCenter/businessCenter.utils';
import withAuthorization from '../../common/helpers/authorization';
import * as mentionsSelectors from '../Activity/activitySchema/mentions.selectos';
import BasicPage from '../Basic/Basic.container';
import * as appConstants from '../App/app.constants';
import EmailsCampaign from './views/EmailsCampaign';
import ActivityMoveTo from '../BusinessCenter/views/ActivityMoveTo/ActivityMoveTo';
import { calculateActivityViewStatus } from '../Activity/activity.selectors.utils';

export class Emails extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function

  static propTypes = {
    campaigns: PropTypes.object,
    businessCenterActions: PropTypes.object.isRequired,
    actions: PropTypes.object,
    emailsLoaded: PropTypes.bool,
    isFiltered: PropTypes.bool,
    filters: PropTypes.object,
    highlightedEmailId: PropTypes.string,
    sort: PropTypes.string,
    searchTerm: PropTypes.string,
    intl: PropTypes.object,
    businessDisplayName: PropTypes.string,
    hasFullPermission: PropTypes.func.isRequired,
    getPermissionLevel: PropTypes.func.isRequired,
    businessBundlePlan: PropTypes.string.isRequired,
    hasBasicPlanPermissions: PropTypes.bool.isRequired,
    transformedMentions: PropTypes.object,
    userAccessGroups: PropTypes.object,
    locationId: PropTypes.number,
    localeDateFormat: PropTypes.string.isRequired,
    localeTimeFormat: PropTypes.string.isRequired,
    businessTimezone: PropTypes.string,
    showToast: PropTypes.bool,
    toastMessage: PropTypes.string,
    campaignIdToFocus: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const { campaigns } = this.props;
    this.state = {
      options: this.genOptions(campaigns) || [],
    };
  }

  componentWillMount() {
    this.props.actions.getEmailsCampaigns();
    this.props.actions.setLoadingState(true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.emailsLoaded && !this.props.emailsLoaded) {
      this.props.actions.setLoadingState(false);
    }
    if (nextProps.campaigns !== this.props.campaigns) {
      this.setState({
        options: this.genOptions(nextProps.campaigns),
      });
    }
  }

  componentDidUpdate(prevProps) {
    // reload on business change
    if (prevProps.locationId !== this.props.locationId) {
      this.props.actions.getEmailsCampaigns();
      this.props.actions.setLoadingState(true);
    }
  }

  componentWillUnmount() {
    this.props.actions.clearEmailList();
  }

  onCreateEmailsCampaign = () => {
    const { formatMessage } = this.props.intl;
    this.props.actions.createEmailsCampaign({
      name: formatMessage({ id: 'emails.campaign.toolbar.create.campaign.untitled' }),
      status: constants.CAMPAIGN_STATUS_ACTIVE
    });
  };

  GetCampaignWithDefaultSort = (campaigns) => {
    if (campaigns) {
      let pinnedCampaigns = campaigns.filter((campaign) => campaign.get(constants.CAMPAIGN_PINNED_DATE) !== null);
      const unpinnedCampaigns = campaigns.filter((campaign) => campaign.get(constants.CAMPAIGN_PINNED_DATE) === null);
      if (pinnedCampaigns && pinnedCampaigns.size > 0) {
        pinnedCampaigns = pinnedCampaigns.sort((a, b) => new Date(b.get(constants.CAMPAIGN_PINNED_DATE)) - new Date(a.get(constants.CAMPAIGN_PINNED_DATE)));
      }
      return pinnedCampaigns.concat(unpinnedCampaigns);
    }
  }

  handleEmailMoveTo = (email) => {
    const moveToCampaign = this.genOptions(this.props.campaigns)
      .filter((campaign) => campaign[constants.CAMPAIGN_ID] !== email.get(constants.CAMPAIGN_KEY));

    if (moveToCampaign.size < 1) {
      return null;
    }

    return this.setState({
      email,
      options: moveToCampaign
    });
  };

  handleOnConfirmActivityMoveTo = (campaignId) => {
    this.props.actions.emailMoveTo(this.state.email, campaignId);
    this.setState({ email: null });
  };

  genOptions = (campaigns) => {
    if (campaigns) {
      return campaigns
        .map((campaign) => ({
          [constants.CAMPAIGN_NAME]: campaign.get(constants.CAMPAIGN_NAME),
          [constants.ID]: campaign.get(constants.CAMPAIGN_ID),
          [constants.CAMPAIGN_STATUS]: campaign.get(constants.CAMPAIGN_STATUS)
        }));
    }
    return [];
  }

  getCampaignById = (id) => this.props.campaigns.find((campaign) => campaign.get(constants.EMAIL_CAMPAIGN_ID) === id)

  handleOnBlur = () => {
    this.props.actions.defocusEmailsCampaign();
  };

  getFullEmailsContents = () => {
    const { formatMessage } = this.props.intl; // eslint-disable-line react/prop-types
    const sideNavBarItems = getSideNavbarSettings(this.props.intl.formatMessage, location, this.props.hasFullPermission, this.props.getPermissionLevel);
    const campaigns = this.GetCampaignWithDefaultSort(this.props.campaigns);
    const campaignIds = campaigns ? campaigns.map((campaign) => campaign.get(constants.CAMPAIGN_ID)).toJS() : undefined;
    return (
      <div>
        <Helmet>
          <title>Emails{this.props.businessDisplayName ? ` - ${this.props.businessDisplayName}` : null}</title>
        </Helmet>
        {this.state.options.size > 0 &&
          <ActivityMoveTo
            open={!!this.state.email}
            onClose={() => this.setState({ email: null })}
            onConfirm={tracker.wrapButtonAction(this.handleOnConfirmActivityMoveTo, trackerConstants.BUTTON_TYPE_MOVE_EMAIL)}
            options={this.state.options}
            activityStatus={this.state.email && calculateActivityViewStatus(this.state.email)}
            popUpContent={formatMessage({ id: 'business-center.emails.email.content.move-to.archived-group' })}
          />
        }
        <SideNavBar sideNavBarItems={sideNavBarItems} />
        <div className="emails">
          <EmailsPageToolbar
            filters={this.props.filters}
            sort={this.props.sort}
            onFilterUpdate={this.props.actions.onFilterUpdate}
            onSortUpdate={this.props.actions.onSortUpdate}
            onSearch={this.props.actions.onSearch}
            searchTerm={this.props.searchTerm}
            isFiltered={this.props.isFiltered}
            createCampaign={this.onCreateEmailsCampaign}
          />
          { campaignIds && campaignIds.map((item, index) => {
            const campaign = this.getCampaignById(item);
            return campaign &&
              <EmailsCampaign
                key={campaign.get(constants.CAMPAIGN_ID)}
                handleOnBlur={this.handleOnBlur}
                emailMoveTo={this.handleEmailMoveTo}
                campaign={campaign}
                campaignIndex={index}
                createEmail={this.props.actions.createEmail}
                saveEmail={this.props.actions.saveEmail}
                locationId={this.props.locationId}
                localeDateFormat={this.props.localeDateFormat}
                localeTimeFormat={this.props.localeTimeFormat}
                businessTimezone={this.props.businessTimezone}
                userAccessGroups={this.props.userAccessGroups}
                updateCampaign={this.props.actions.updateEmailsCampaign}
                updateEmailStatus={this.props.actions.updateEmailStatus}
                openEmailInNewTab={this.props.businessCenterActions.openActivityInNewTab}
                goToEmail={this.props.actions.goToEmail}
                hasFullPermission={this.props.hasFullPermission}
                transformedMentions={this.props.transformedMentions}
                pinCampaign={this.props.actions.pinEmailsCampaign}
                openToast={this.props.actions.openToast}
                focus={item === this.props.campaignIdToFocus}
              />;
          })}
        </div>
      </div>
    );
  }

  getBasicEmailsContents = () => {
    const { formatMessage } = this.props.intl; // eslint-disable-line react/prop-types
    const campaigns = this.GetCampaignWithDefaultSort(this.props.campaigns);
    const campaignIds = campaigns ? campaigns.map((campaign) => campaign.get(constants.CAMPAIGN_ID)).toJS() : undefined;
    return (
      <BasicPage isEmails>
        <Helmet>
          <title>Emails{this.props.businessDisplayName ? ` - ${this.props.businessDisplayName}` : null}</title>
        </Helmet>
        <div className="emails">
          <EmailsPageToolbar
            filters={this.props.filters}
            sort={this.props.sort}
            onFilterUpdate={this.props.actions.onFilterUpdate}
            onSortUpdate={this.props.actions.onSortUpdate}
            onSearch={this.props.actions.onSearch}
            searchTerm={this.props.searchTerm}
            isFiltered={this.props.isFiltered}
            createCampaign={this.onCreateEmailsCampaign}
          />
          { campaignIds && campaignIds.map((item, index) => {
            const campaign = this.getCampaignById(item);
            return campaign &&
              <EmailsCampaign
                key={campaign.get(constants.CAMPAIGN_ID)}
                handleOnBlur={this.handleOnBlur}
                emailMoveTo={this.handleEmailMoveTo}
                campaign={campaign}
                campaignIndex={index}
                createEmail={this.props.actions.createEmail}
                saveEmail={this.props.actions.saveEmail}
                locationId={this.props.locationId}
                localeDateFormat={this.props.localeDateFormat}
                localeTimeFormat={this.props.localeTimeFormat}
                businessTimezone={this.props.businessTimezone}
                userAccessGroups={this.props.userAccessGroups}
                updateCampaign={this.props.actions.updateEmailsCampaign}
                updateEmailStatus={this.props.actions.updateEmailStatus}
                openEmailInNewTab={this.props.businessCenterActions.openActivityInNewTab}
                goToEmail={this.props.actions.goToEmail}
                hasFullPermission={this.props.hasFullPermission}
                transformedMentions={this.props.transformedMentions}
                pinCampaign={this.props.actions.pinEmailsCampaign}
                openToast={this.props.actions.openToast}
                focus={item === this.props.campaignIdToFocus}
              />;
          })}
        </div>
      </BasicPage>
    );
  }

  render() {
    const { formatMessage } = this.props.intl; // eslint-disable-line react/prop-types
    const sideNavBarItems = getSideNavbarSettings(this.props.intl.formatMessage, location, this.props.hasFullPermission, this.props.getPermissionLevel);
    return (
      <>
        {this.props.businessBundlePlan === appConstants.TRIAL ? this.getBasicEmailsContents() : this.getFullEmailsContents()}
        <Toast
          // eslint-disable-next-line react/prop-types
          intl={this.props.intl}
          isOpen={this.props.showToast}
          messageKey={this.props.toastMessage}
          onClose={() => this.props.actions.closeToast()}
          secondsToShow={3}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: emailsSelectors.getFilteredAndSortedCampaignsEmails(state),
  transformedMentions: mentionsSelectors.getEmailMentionsTransformed(state),
  emailsLoaded: emailsSelectors.getEmailsLoadedFlag(state),
  highlightedEmailId: emailsSelectors.getHighlightedEmailId(state),
  sort: emailsSelectors.getOrder(state),
  isFiltered: emailsSelectors.isCampaignsFiltered(state),
  searchTerm: emailsSelectors.getSearchTerm(state),
  businessDisplayName: appSelectors.getBusinessDisplayName(state),
  businessBundlePlan: appSelectors.getBusinessBundlePlan(state),
  hasBasicPlanPermissions: appSelectors.hasBasicPlanPermissions(state),
  filters: emailsSelectors.getFilters(state),
  userAccessGroups: appSelectors.getUserAccessGroups(state),
  locationId: appSelectors.getLocationId(state),
  localeDateFormat: appSelectors.getBrowserLocaleDateFormat(state),
  localeTimeFormat: appSelectors.getBrowserLocaleTimeFormat(state),
  businessTimezone: appSelectors.getBusinessTimeZone(state),
  showToast: emailsSelectors.getToastState(state),
  toastMessage: emailsSelectors.getToastMessage(state),
  campaignIdToFocus: emailsSelectors.getFocusedCampaignId(state),
});

function mapDispatchToProps(dispatch) {
  return {
    businessCenterActions: bindActionCreators({ ...businessCenterActions }, dispatch),
    actions: bindActionCreators(Object.assign({}, emailsActions, { setLoadingState }), dispatch),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = injectSaga({ key: routerConstants.EMAILS_BRANCH, saga });
const withBusinessSaga = injectSaga({ key: routerConstants.BUSINESS_CENTER_BRANCH, saga: businessSaga });


export default compose(withSaga, withBusinessSaga, withConnect, withAuthorization, injectIntl)(Emails);
